import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App'

import { initI18N } from '../../i18next';

const params = new URLSearchParams(window.location.search);
const paylinkId = params.get('id');

const container = document.querySelector("div[id^='paylink-app'");

initI18N().then(() => {
    const root = createRoot(container);
    root.render(<App paylinkId={paylinkId} />);
});